import React, { Component } from 'react';

export class UserApprovalFilter extends Component {

    statusSelectionChanged(e) {
        this.props.onStatusChange(e.target.value);
    }

    render() {
        return (
            <div className="advanced-filter show careers-results no-top-margin">
                <div className="select-wrap a-select">
                    <label>Status</label>
                    <select name="filterStatus" value={this.props.filterStatus} onChange={(e) => this.statusSelectionChanged(e)}>
                        <option value="Submitted">Submitted</option>
                        <option value="Approved">Approved</option>
                        <option value="Denied">Denied</option>
                    </select>
                </div>
            </div>
        );
    }
}